import { SentenceType, TagType } from 'types/types'
import { computed, Ref } from 'vue'
import { VueLogger } from 'vue-logger-plugin'

import store from '@/store'
import { SentenceRecordingMetadataWithPitchedAudios } from '@/util/AudioUtil'
import { isRead } from '@/util/RecordingHelpers'
import { filterHiddenTags, filterVisibleTags, sortByTagOrder } from '@/util/Tags'
import { inReadMode, inTextMode, VoiceStyleSet } from '@/util/VoiceStyles'

const computeChoosableTags = (payload: { sentences: Array<SentenceType>; voiceStyleSet: VoiceStyleSet; logger?: VueLogger }) => {
  // no tags for Text mode
  if (inTextMode(payload.voiceStyleSet)) {
    return new Array<TagType>()
  }

  // compile a list of available tags for recordings associated with the
  // current sentence and style selection
  const tags = new Map<string, TagType>()

  payload.sentences.forEach((sentence: SentenceType) => {
    if (!store.getters.audio.hasRecordingsForSentence(sentence.id)) {
      return
    }
    store.getters.audio.getRecordingListForSentence(sentence.id).forEach((srmd: SentenceRecordingMetadataWithPitchedAudios) => {
      const { sentenceRecording } = srmd
      if (!sentenceRecording) {
        return
      }
      if (isRead(srmd) === inReadMode(payload.voiceStyleSet)) {
        sentenceRecording.tags.forEach((tag: TagType) => {
          tags.set(tag.name, tag)
        })
      }
    })
  })

  const uniqueTags = Array.from(tags.values())

  const r = sortByTagOrder(Array.from(uniqueTags.values()))

  payload.logger && payload.logger.debug('choosableTags.value =')
  payload.logger && payload.logger.debug(r)
  return r
}

const useChoosableTags = (sentences: Ref<Array<SentenceType>>, voiceStyleSet: Ref<VoiceStyleSet>, logger: VueLogger) => {
  const choosableTags = computed<Array<TagType>>(() => {
    return computeChoosableTags({ logger, sentences: sentences.value, voiceStyleSet: voiceStyleSet.value })
  })

  const choosableHiddenTags = computed<Array<TagType>>(() => {
    return filterHiddenTags(choosableTags.value)
  })

  const choosableNonHiddenTags = computed<Array<TagType>>(() => {
    return filterVisibleTags(choosableTags.value)
  })

  return { choosableHiddenTags, choosableNonHiddenTags, choosableTags }
}

export { computeChoosableTags, useChoosableTags }
